module.exports = __webpack_public_path__ + "static/media/jason-momoa-photo-1.505b9dea.jpg";